import SaveIcon from '@material-ui/icons/Save';
import SaveAltOutlinedIcon from '@material-ui/icons/SaveAltOutlined';
import GroupAddOutlinedIcon from '@material-ui/icons/GroupAddOutlined';
import PlayArrowOutlinedIcon from '@material-ui/icons/PlayArrowOutlined';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import renameIcon from 'assets/svgs/rename.svg';

import {
	EDIT,
	RENAME,
	DELETE,
	ADD_TO_SAVED,
	DOWNLOAD,
	DOWNLOAD_AGAIN,
	SHARE,
	RUN_NOW,
	LEAVE,
	CREATE_COPY,
	RUN_AGAIN,
	PREVIEW_READY_CREATE_REPORT
} from 'constants/constant';

export function getDraftMenuListItem() {
	const item = [
		{
			disabled: false,
			name: `${EDIT} & ${PREVIEW_READY_CREATE_REPORT}`,
			icon: <EditIcon />,
			id: 'edit'
		},
		{
			disabled: false,
			name: RENAME,
			icon: (
				<div>
					<img src={renameIcon} alt="article-icon" />
				</div>
			),
			divider: true,
			id: 'rename'
		},
		{
			disabled: false,
			name: DELETE,
			icon: <DeleteIcon />,
			id: 'delete'
		}
	];
	return item;
}

export function getReportMenuListItem() {
	const item = [
		{
			name: EDIT,
			icon: <EditIcon />,
			id: 'edit'
		},
		{
			name: ADD_TO_SAVED,
			icon: <SaveIcon />,
			id: 'add_to_saved'
		},
		{
			name: DOWNLOAD,
			alternetName: DOWNLOAD_AGAIN,
			icon: <SaveAltOutlinedIcon />,
			id: 'download'
		},
		{
			name: DELETE,
			icon: <DeleteIcon />,
			id: 'delete'
		},
		{
			name: RUN_AGAIN,
			icon: <PlayArrowOutlinedIcon />,
			id: 'run_again'
		},
		{
			name: SHARE,
			icon: <GroupAddOutlinedIcon />,
			id: 'share'
		},
		{
			name: RUN_NOW,
			icon: <PlayArrowOutlinedIcon />,
			id: 'run_now'
		}
	];
	return item;
}

export function getSharedReportMenuListItem() {
	const item = [
		{
			name: CREATE_COPY,
			icon: <EditIcon />,
			id: 'edit'
		},
		{
			name: ADD_TO_SAVED,
			icon: <SaveIcon />,
			id: 'add_to_saved'
		},
		{
			name: DOWNLOAD,
			alternetName: DOWNLOAD_AGAIN,
			icon: <SaveAltOutlinedIcon />,
			id: 'download'
		},
		{
			name: LEAVE,
			icon: <DeleteIcon />,
			id: 'leave_report',
			divider: true
		}
	];
	return item;
}
